(function () {
  const TEXT_FROM = 'Out of stock';
  const TEXT_TO = '';
  //const TEXT_TO = 'Pre-order — ships soon';

  function updateStockText() {
    document.querySelectorAll('.stock.false').forEach(el => {
      if (el.textContent.includes(TEXT_FROM)) {
        el.childNodes.forEach(node => {
          if (node.nodeType === Node.TEXT_NODE) {
            node.textContent = TEXT_TO;
          }
        });
      }
    });
  }

  // Run immediately
  updateStockText();

  // Observe ALL DOM changes (NEXT re-renders cart)
  const observer = new MutationObserver(updateStockText);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
